/**
 * collection-load-more.js
 * Adds a "Load more" button to the collection grid.
 *
 * Reads the next-page link the theme already renders
 * (a.pagination-custom__next), so the real ?page=N URLs stay in the DOM
 * for crawlers. If anything fails, the original numbered pagination is
 * restored and the customer can keep browsing normally.
 */
(function () {
  'use strict';

  var LOADING = 'Chargement…';

  var pageSize = 0;
  var currentNav = null;

function moreLabel() {
    return "+ Afficher plus d'articles";
  }

function countText(n) {
    return n + (n > 1 ? ' articles affichés' : ' article affiché');
  }

  // Counts real product cards, skipping any featured-image blocks.
  function countProducts(grid) {
    var n = 0;
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].querySelector('a[href*="/products/"]')) n++;
    }
    return n;
  }

  function findParts() {
    var outer = document.querySelector('.grid-outer');
    if (!outer) return null;
    var grid = outer.querySelector('#CollectionLoop');
    var nav = outer.querySelector('.pagination-custom');
    if (!grid || !nav) return null;
    return { outer: outer, grid: grid, nav: nav };
  }

  function restore(parts, btn, count) {
    if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    if (count && count.parentNode) count.parentNode.removeChild(count);
    parts.nav.style.display = '';
  }

  function load(parts, btn, count) {
    var url = btn.dataset.url;
    if (!url || btn.disabled) return;

    var span = btn.querySelector('span');
    btn.disabled = true;
    span.textContent = LOADING;

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('#CollectionLoop');
        if (!incoming || !incoming.firstElementChild) {
          throw new Error('No products found in response');
        }

        var frag = document.createDocumentFragment();
        while (incoming.firstElementChild) {
          frag.appendChild(incoming.firstElementChild);
        }
        parts.grid.appendChild(frag);

        count.textContent = countText(countProducts(parts.grid));

        var nextLink = doc.querySelector('a.pagination-custom__next[href]');
        if (nextLink) {
          btn.dataset.url = nextLink.getAttribute('href');
          btn.disabled = false;
          span.textContent = moreLabel();
        } else {
          btn.parentNode.removeChild(btn);
        }

        try {
          window.history.replaceState(null, '', url);
        } catch (e) {
          /* replaceState can throw in sandboxed contexts; not fatal */
        }

        document.dispatchEvent(
          new CustomEvent('collection:productsAdded', {
            bubbles: true,
            detail: { url: url }
          })
        );
      })
      .catch(function () {
        restore(parts, btn, count);
      });
  }

  function init() {
    var parts = findParts();
    if (!parts) return;

    if (parts.nav === currentNav) return;
    currentNav = parts.nav;

    var stale = parts.outer.querySelector('.collection-load-more');
    if (stale) stale.parentNode.removeChild(stale);
    var staleCount = parts.outer.querySelector('.collection-load-more__count');
    if (staleCount) staleCount.parentNode.removeChild(staleCount);

    var nextLink = parts.nav.querySelector('a.pagination-custom__next[href]');
    if (!nextLink) return;

    pageSize = countProducts(parts.grid) || 48;
    parts.nav.style.display = 'none';

    var count = document.createElement('p');
    count.className = 'collection-load-more__count';
    count.style.cssText =
      'text-align:center;margin:32px 0 12px;opacity:.65;font-size:14px;';
    count.setAttribute('aria-live', 'polite');
    count.textContent = countText(pageSize);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn caps btn--primary btn--outline collection-load-more';
    btn.style.cssText = 'display:block;margin:0 auto;';
    btn.dataset.url = nextLink.getAttribute('href');
    btn.innerHTML = '<span></span>';
    btn.querySelector('span').textContent = moreLabel();

    btn.addEventListener('click', function () {
      load(parts, btn, count);
    });

    parts.nav.insertAdjacentElement('afterend', count);
    count.insertAdjacentElement('afterend', btn);
  }

  function watch() {
    var outer = document.querySelector('.grid-outer');
    if (!outer || !window.MutationObserver) return;

    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(init, 100);
    }).observe(outer, { childList: true, subtree: true });
  }

  function start() {
    init();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();